import { useCallback, useEffect, useState } from "react";

import { Echo } from "@/lib/echo";
import { useFetchMe } from "@/user/services";
import { useTenant } from "@/user/services/tenant";

import { type Notification } from "../types";

export function useNotificationChannel() {
  const { data: user } = useFetchMe();
  const tenant = useTenant();

  const [notifications, setNotifications] = useState<Notification[]>([]);

  const handleNotification = useCallback(
    ({ notification }: { notification: Notification }) => {
      setNotifications((prev) => [...prev, notification]);
    },
    [],
  );
  useEffect(() => {
    if (!user?.id) return;

    Echo.private(`${tenant.id}.users.${user.id}`).listen(
      ".NotificationCreated",
      handleNotification,
    );

    return () => {
      Echo.private(`${tenant.id}.users.${user.id}`).stopListening(
        ".NotificationCreated",
        handleNotification,
      );
      Echo.leave(`${tenant.id}.users.${user.id}`);
    };
  }, [user?.id, tenant.id, handleNotification]);

  return { notifications, setNotifications };
}
